export default __webpack_public_path__ + "static/907-441c28e75a21b4eb994210f72f5bcb45.gif";